import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function PaymentApplyList(props) {
  const Config = {
    purchase: {
      apiPath: '/paymentApply/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/payment/apply/detail',
      searchBarPlaceholder: '供应商名称/编码、申请单号',
      orderProperty: 'createTime',
      tabs: ['全部'],
      arrEnumField: [
        {
          mainKey: 'B02_Pay_Apply_status',
          subKey: 'status',
          value: 'statusName'
        }
      ]
    },
    sale: {
      apiPath: '/customerPaymentApply/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/cust-payment/apply/detail',
      searchBarPlaceholder: '客户名称/编码、申请单号',
      orderProperty: 'createTime',
      tabs: ['全部'],
      arrEnumField: [
        {
          mainKey: 'B02_Pay_Apply_status',
          subKey: 'status',
          value: 'statusName'
        }
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.pmaXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.pmaInnerNo || item.pmaXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('pma', item.status)
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                        <li>
                          <label>付款申请合计</label>
                          <div>
                            {formatNumber(
                              item.applyTotalTaxAmount,
                              item.AMOUNT
                            )}
                          </div>
                        </li>
                        <li>
                          <label>来源</label>
                          {self.isPurchase && (
                            <div>
                              {item.sourceType === 1 ? '本方' : '供应商'}
                            </div>
                          )}
                          {!self.isPurchase && (
                            <div>
                              {item.sourceType === 2 ? '本方' : '供应商'}
                            </div>
                          )}
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PaymentApplyList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PaymentApplyList);
